import { z } from 'zod';

export const VALIDATION_MESSAGES = {
  required: 'Campo obrigatório',
  weakPassword:
    'A senha deve ter no mínimo 8 caracteres, incluindo letras e números',
  noMatch: 'A senha não corresponde com a informada no campo acima',
};

const passwordSchema = z
  .string()
  .min(1, VALIDATION_MESSAGES.required)
  .min(8, VALIDATION_MESSAGES.weakPassword)
  .refine(
    (password) => {
      const hasNumber = /\d/.test(password);
      const hasLetter = /[a-zA-Z]/.test(password);
      return hasNumber && hasLetter;
    },
    { message: VALIDATION_MESSAGES.weakPassword }
  );

export const passwordFormSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string().min(1, VALIDATION_MESSAGES.required),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: VALIDATION_MESSAGES.noMatch,
    path: ['confirmPassword'],
  });

export type PasswordFormData = z.infer<typeof passwordFormSchema>;
